import { motion } from "framer-motion";

export default function SectionHeading({ number, caption, title, sub, dark = false, align = "left" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`mb-12 sm:mb-16 ${align === "center" ? "text-center" : ""}`}
    >
      <div className={`flex items-baseline gap-4 ${align === "center" ? "justify-center" : ""}`}>
        <span className="font-mono text-sm font-bold text-rescue">{number}</span>
        <span
          className={`font-mono text-xs font-bold uppercase tracking-[0.25em] ${
            dark ? "text-blue-300" : "text-blue-600"
          }`}
        >
          {caption}
        </span>
      </div>
      <h2
        className={`mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {sub && (
        <p
          className={`mt-4 max-w-2xl text-base leading-relaxed sm:text-lg ${
            dark ? "text-slate-300" : "text-slate-600"
          } ${align === "center" ? "mx-auto" : ""}`}
        >
          {sub}
        </p>
      )}
    </motion.div>
  );
}
